/* src/components/pdf-page-forecast-end-result-list/pdf-page-forecast-end-result-list.component.scss */
app-pdf-page-forecast-end-result-list {
  display: block;
}
.table-col--score {
  width: 16mm;
  max-width: 16mm;
}
.table-col--best-guess,
.table-col--min-costs,
.table-col--max-costs {
  width: 30mm;
  max-width: 30mm;
}
/*# sourceMappingURL=pdf-page-forecast-end-result-list.component-GSVREJBR.css.map */
